import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  return <section className="relative bg-au-green text-white py-24 md:py-32" data-id="element-128">
      <div className="max-w-7xl mx-auto px-4" data-id="element-129">
        <div className="max-w-4xl" data-id="element-130">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-131">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif mb-6 leading-tight" data-id="element-132">
              Advancing Africa's Global Partnerships for Sustainable Development
            </h1>
            <div className="w-32 h-1 bg-au-gold mb-6" data-id="element-133"></div>
            <p className="text-xl md:text-2xl text-au-green-light mb-8 leading-relaxed" data-id="element-134">
              The African Union Commission connects Africa with partners across
              the world — driving transformative projects in health, education,
              trade, and infrastructure to foster prosperity and inclusive
              growth globally.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-135">
              <Link to="/projects" data-id="element-136">
                <Button variant="primary" className="flex items-center gap-2" data-id="element-137">
                  Explore Our Projects
                  <ArrowRightIcon size={20} data-id="element-138" />
                </Button>
              </Link>
              <Link to="/bids" data-id="element-139">
                <Button variant="secondary" className="bg-white" data-id="element-140">
                  View Current Bids
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-2 bg-au-gold" data-id="element-141"></div>
    </section>;
}